export class QuoteAddressModel {
  id?: number;
  quote_id?: number;
  address_line_1?: string;
  address_line_2?: string;
  suburb?: string;
  city?: string;
  town_city?: string;
  region?: string;
  state_region?: string;
  post_code?: string;
  country?: string;
  instruction?: string;
  is_warehouse_collection?: number;
  is_sales_rep_delivery?: boolean;
  shipping_truck_type_id?: number;
  other_truck_type_name?: string;
  shipping_zone?: string;
  shipping_zone_id?: number;
  shipping_region_id?: number;
  is_select_default_business_address?: string;
  is_default?: boolean;
  in_shipping_zone?: string;
  shipping_rate?: number;
  address_type?: string | null; // Residential, Business, PO Box, Unknown (set by the API); NULL = not checked yet
}
